import {
  SortDirectionSchema,
  type SortDirection as GeneratedSortDirection
} from '~/services/api/generated'

// Mirrors backend App\Enums\SortDirection

export type SortDirection = GeneratedSortDirection

export const SortDirection = {
  ASCENDING: SortDirectionSchema.enum.asc,
  DESCENDING: SortDirectionSchema.enum.desc
} satisfies Record<string, GeneratedSortDirection>

export const SortDirectionValues: readonly GeneratedSortDirection[] = [
  SortDirectionSchema.enum.asc,
  SortDirectionSchema.enum.desc
]
